import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { NotificationBadge } from 'foundations-components/transitional/components/NotificationBadge';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { useAssignedTasks } from 'setup-guide-api/dataFetchingClient/queries/assignedTasks';
import { useTaskDataByGroupKey } from '../../../hooks/task';
import { FeatureSwitch } from '../../FeatureSwitch';
import { FEATURE_SWITCH_APPS } from '../../FeatureSwitch';
import { useMemo, useEffect } from 'react';
import { useTracker } from '../../../hooks/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getFirstGroupKeyOverride = (openTasksInGroup, taskMap) => {
  var _taskMap;
  const firstGroupKey = openTasksInGroup.find(task => Boolean(taskMap[task.key || '']));
  return (_taskMap = taskMap[(firstGroupKey === null || firstGroupKey === void 0 ? void 0 : firstGroupKey.key) || '']) === null || _taskMap === void 0 ? void 0 : _taskMap.handholdingGroupKeyOverride;
};
const AssignedTaskNotificationRendered = ({
  onGroupClick,
  viewGroupKey,
  children = /*#__PURE__*/_jsx("span", {}),
  isInHeader = false
}) => {
  const {
    trackUserInteraction,
    trackSectionView
  } = useTracker();
  const {
    assignedOnboardingTasks = []
  } = useAssignedTasks();
  const {
    taskMap = {}
  } = useTaskDataByGroupKey(viewGroupKey);
  const openTasksInGroup = useMemo(() => {
    return assignedOnboardingTasks.filter(task => !(task !== null && task !== void 0 && task.assigneeCompletedTask) && !(task !== null && task !== void 0 && task.assigneeSkippedTask) && taskMap[task === null || task === void 0 ? void 0 : task.key]);
  }, [assignedOnboardingTasks, taskMap]);
  const firstGroupKeyOverride = getFirstGroupKeyOverride(openTasksInGroup, taskMap);
  useEffect(() => {
    if (openTasksInGroup.length > 0) {
      trackSectionView(`assigned task notification view ${isInHeader ? 'header' : 'task'}`, firstGroupKeyOverride || '');
    }
  }, [isInHeader, firstGroupKeyOverride, openTasksInGroup.length, trackSectionView]);
  const handleGroupClick = groupKey => {
    if (onGroupClick) {
      trackUserInteraction('assigned task notification', 'click', {
        groupKey,
        viewGroupKey,
        isInHeader
      });
      onGroupClick(groupKey);
    }
  };
  if (!openTasksInGroup.length || !firstGroupKeyOverride) {
    return /*#__PURE__*/_jsx(View, {
      margin: "200",
      children: children
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    gap: "200",
    children: [/*#__PURE__*/_jsx(NotificationBadge, {
      badgeDescription: I18n.text('setup-guide-components.assignTaskNotification.title'),
      badgeLabel: openTasksInGroup.length,
      placement: "inline",
      showBadge: true,
      children: /*#__PURE__*/_jsx(View, {
        marginInlineEnd: "200",
        children: children
      })
    }), isInHeader && onGroupClick && /*#__PURE__*/_jsx(Link, {
      onClick: () => handleGroupClick(firstGroupKeyOverride),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.assignTaskNotification.title"
      })
    })]
  });
};
export default function AssignedTaskNotification(_ref) {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(FeatureSwitch, {
    allowedApps: [FEATURE_SWITCH_APPS.USER_GUIDE],
    fallback: props.children,
    children: /*#__PURE__*/_jsx(AssignedTaskNotificationRendered, Object.assign({}, props))
  });
}